/* eslint-disable no-shadow */
const state = {
	allPromotions: []
}

const getters = {
	getAllPromotions: state => state.allPromotions
}

const mutations = {
	setAllPromotionsMutation: (state, payload) => {
		state.allPromotions = payload
	}
}

const actions = {
	setAllPromotions: ({
		commit
	}, payload) => {
		commit('setAllPromotionsMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
